import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  Navigate,
} from "react-router-dom";
import { Fragment, useEffect } from "react";
// import Main from "./components/main/main";
// import Meter from "./components/meter/meter";
// import Dip from "./components/dip/dips";
import Report from "./components/Report/stockBalance/report";
import DayBook from "./components/Report/dayBook/report";
import Login from "./components/User/login";
// import Purchase from "./components/purchase/purchase";
import { useSelector, useDispatch } from "react-redux";
import { authSelector } from "./store/selectors/index";
import { logoutAction } from "./store/actions/auth.action";
import Receipts from "./components/receipts/receipts";
// import Cards from "./components/cards/cards";
// import Credits from "./components/credits/credits";
import Payment from "./components/payment/payment";
import JV from "./components/journalVoucher/journalVoucher";
// import LubeSale from "./components/lubeSale/lubeSale.jsx";
// import OpeningStock from "./components/openingStock/openingStock";
import ChartOfAccount from "./components/chartOfAccount/chartOfAccount";
import Party from "./components/party/party";
import Register from "./components/User/registerUser";

// import Example from "./components/Report/calling";
import jwt_decode from "jwt-decode";
// import Nozel from "./components/nozel/nozel";
// import Tank from "./components/tank/tank";
import MainScreen from "./components/mainScreen/mainScreen";
import Booking from "./components/booking/booking.jsx";
import PrivateRoute from "./privateRoutes/privateRoute";
// import Vehical from "./components/vehicals/vehicals";
// import Coupon from "./components/couponIssued/couponIssued";
import Item from "./components/item/item";
// import Dipchart from "./components/dipcharts/dipchart";
// import OpeningBalGL from "./components/openingBalGl/openingBalGl";
// import BulkSale from "./components/bulkSale/bulkSale";
// import BulkPurchase from "./components/bulkPurchase/bulkPurchase";
import ReportsComponent from "./components/allReport/reportsComponent";
import GLedger from "./components/Report/GLedger/report";
import PLedger from "./components/Report/PLedger/report";
// import FuelSaleStockReg from "./components/Report/fuelSaleRegister/report";
// import PurchaseRegister from "./components/Report/purchaseRegister/report";
// import SaleRegister from "./components/Report/saleRegister/report";
// import TrialBalance from "./components/Report/trialBalance/report.jsx";
// import DailySheet from "./components/Report/dailySheet/report.jsx";
// import PartyBill from "./components/Report/partyBill/report.jsx";
// import SpecialRate from "./components/specialRate/specialRate.jsx";
import BankVoucher from "./components/bankVoucher/bankVoucher.jsx";
import Expense from "./components/expense/expense.jsx";
// import CustomerBillSummary from "./components/Report/customerBillSummary/report.jsx";
// import CustomerBillSummaryItemWise from "./components/Report/customerBillSummaryItemWise/report.jsx";
// import CreditSaleSheetEWise from "./components/Report/creditSaleSheet/report.jsx";
// import CreditSaleSheetCustomerVehicleWise from "./components/Report/creditSaleSheetCustomerVehicleWise/report.jsx";
// import ProfitLoss from "./components/Report/profitLoss/report.jsx";
// import LogSheet from "./components/Report/logSheet/report.jsx";
// import PettyExpense from "./components/pettyExpense/pettyExpense.jsx";
// import VehicleExpReg from "./components/Report/vehicleExpReport/report.jsx";
// import RateGainLoss from "./components/rateGainLoss/rateGainLoss.jsx";
// import TankLorry from "./components/tankLorry/tankLorry.jsx";
// import TankLorryReport from "./components/Report/tankLorryReport/report.jsx";
// import RateGainReport from "./components/Report/rateGainLoss/report.jsx";
// import BulkSaleRegister from "./components/Report/bulkSaleRegister/report.jsx";
// import BulkSalePurchaseStockReg from "./components/Report/bulkSalePurchaseRegister/report.jsx";
// import DailySheetNonPDF from "./components/Report/dailySheetYasir/report.jsx";
// import EntryVerification from "./components/Report/entryVerification/report.jsx";
// import SaleTaxInv from "./components/Report/saleTaxInv/report.jsx";
import Alert from "./components/alert/alert.jsx";
import BookingEvents from "./components/Report/bookingEvents/report.jsx";
// import NSalePurchaseStockReg from "./components/Report/nSalePurchaseRegister/report.jsx";

// import PdfViewer from "./components/Report/dayBookPdf/component";

function App() {
  // const { loading } = useUserContext();

  return (
    <Router>
      {/* {loading && <Loader />} */}
      <AppRoutes />
    </Router>
  );
}

function AppRoutes() {
  const { user, access_token } = useSelector(authSelector);
  const isAuth = user && access_token ? true : false;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const token = access_token;

    if (token) {
      const decodedToken = jwt_decode(token);
      const currentTime = Date.now() / 1000;

      // Check if token is expired
      // Set timer to log out user when token expires
      const expirationTime = decodedToken.exp - currentTime;

      setTimeout(() => {
        console.log("setTimeOut");
        dispatch(logoutAction());
        navigate("/");
      }, expirationTime * 1000);
    }
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Routes>
        {isAuth ? (
          <Fragment>
            {/* <Route path="/main" element={<Main />}></Route> */}
            <Route path="/mainScreen" element={<MainScreen />}></Route>
            {/* <Route
              path="/meter"
              element={user.role === "admin" ? <Meter /> : <Main />}
            ></Route> */}
           
            <Route path="/booking" element={<Booking />}></Route>
            <Route path="/receipts" element={<Receipts />}></Route>
            <Route path="/payment" element={<Payment />}></Route>
            <Route path="/journalVoucher" element={<JV />}></Route>
            {/* <Route path="/report" element={<Report />}></Route> */}
            <Route path="/chartOfAccount" element={<ChartOfAccount />}></Route>
            <Route path="/party" element={<Party />}></Route>
            <Route path="/daybook" element={<DayBook />}></Route>
            {/* <Route path="/nSalePurchase" element={<NSalePurchaseStockReg />}></Route> */}
            <Route
              path="/reportsComponent"
              element={<ReportsComponent />}
            ></Route>
            <Route path="/GLedger" element={<GLedger />}></Route>
            <Route path="/eventReport" element={<BookingEvents/>}></Route>
            <Route path="/PLedger" element={<PLedger />}></Route>
            <Route path="/alert" element={<Alert />}></Route>


            {/* <Route
              path="/bankVoucher"
              element={
                <PrivateRoute
                  element={<BankVoucher />}
                  allowedRoles={["user", "admin"]}
                />
              }
            />
            <Route
              path="/expenseVoucher"
              element={
                <PrivateRoute
                  element={<Expense />}
                  allowedRoles={["user", "admin"]}
                />
              }
            /> */}

            <Route
              path="/registerUser"
              element={
                <PrivateRoute element={<Register />} allowedRoles={["", ""]} />
              }
            ></Route>

            {/* <Route path="/PP" element={<PdfViewer />}></Route> */}

            {/* <Route path="/stockBalence" element={<Example />}></Route> */}

            <Route path="*" element={<Navigate to="/mainScreen" replace />} />
          </Fragment>
        ) : (
          <Fragment>
            <Route path="/" element={<Login />}></Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Fragment>
        )}
      </Routes>
    </>
  );
}

export default App;
